import React from "react";
import ShadableEntityIcon from "../../../../../common/ShadableEntityIcon";
import EntityName from "../../EntityName";

type Props = {
    name: string;
    color: string;
    url?: string;
}

const StageTitle = (props: Props) => {
    return <EntityName
        name={props.name}
        url={props.url}
        replaceCurrentUrl
        renderLogo={() => (
            <ShadableEntityIcon
                color={props.color}
                percent={0.85}
                iconName="PPMXProcessStage"
                classNames={{ root: "process-stage-logo" }}
            />
        )}>

    </EntityName>
}

export default StageTitle;